module["exports"] = [
  "Esc. ###",
  "Puerta ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/address/secondary_address.js
// module id = 1576
// module chunks = 0